import Moment from "moment";
import React, { useState } from "react";
import convertUnicodeEmoji from "../../actions/convertUnicodeEmoji";
import testJson from "../../actions/testJson";
import ICONPDFEXPORT from '../../build/images/pdf.svg';
import AVI from "../../build/images/avi-file.png";
import WHATSAPP from '../../build/images/whatsapp_icon.svg';
import VIDEO from "../../build/images/video.jpg";
import AUDIO from "../../build/images/audio.svg";
import FOTO from "../../build/images/foto.svg";
import DOC from "../../build/images/doc.svg";
import Lightbox from "react-image-lightbox";
import JPG from "../../build/images/jpg-file.png";
import XLS from "../../build/images/media-icon.png";
import PDF from "../../build/images/pdf-file.png";
import MP3 from "../../build/images/mp3-file.png";
import latinize from "latinize";
import Highlighter from "react-highlight-words";
import { dbfileSize, SearchingHistoryData } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import MicroModal from 'micromodal'; 

const {meses} = require("../../services/data");
const { connection_platform } = require("../../services/api");

let timedefaultinitmanager = Moment().format("YYYY-MM-DDT00:00");
let timedefaultfimmanager = Moment().format("YYYY-MM-DDT23:59");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern
var port = connection_platform.port_backend_intern;

if(gethostname === 'localhost')
  pathname = iplocal;
else
  pathname = gethostname;

var ipcurrent = pathname;

if(pathname !== connection_platform.ip_intern){
    ipcurrent = connection_platform.ip_apache_view_extern;
   // if(parseInt(connection_platform.port_apache_view_extern) !== 80){
       ipcurrent = ipcurrent+':'+connection_platform.port_apache_view_extern;
    //}
}else{
    ipcurrent = connection_platform.ip_apache_view_intern;
   // if(parseInt(connection_platform.port_apache_view_intern) !== 80){
        ipcurrent = ipcurrent+':'+connection_platform.port_apache_view_intern;
    //}
}

let dia = "";
let mes = "";
let ano = "";
let auxdia = "";
let checkreply = false;
let descHistory = [];

export default function HistoricCallModal({clientQueueMax}){
    const [searchText, setSearchText] = useState("");
    const InfoUsers = useSelector(state => state.informationusers)
    const [showHistory, setShowHistory] = useState(false);
    const [arrowterm, setArrowTerm] = useState(0);
    const [histStart, setHistStart] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [urlimage, setUrlImage] = useState("");
    const [histEnd, setHistEnd] = useState("");
    const HistoryData = useSelector(state => state.history);
    let idgroup = InfoUsers.idgroup;
    const dispatch = useDispatch();
    let nameClient = clientQueueMax.length !== 0 ? clientQueueMax[0].queueContactname !== " " ? convertUnicodeEmoji(clientQueueMax[0].queueContactname):clientQueueMax[0].queueCaller:"";
    
    const SearchHistoryQueue = () => {
        let histstart = histStart;
        let histend = histEnd;

        // if(histend !== "" || histstart !== "")
            dispatch(SearchingHistoryData(histstart, histend, 33, clientQueueMax[0].queueCaller,idgroup));
        // this.setState({datapdfend: histend, datapdfinit: histend})
    }

    const CloseImage = (e,modal) => {
        setIsOpen(false);
        setUrlImage("")
        MicroModal.show('modal__historico-atendimento_manager_new');
      }

    const VerifierImage = (e,urlimage,modal) => {
        setIsOpen(true);
        setUrlImage(urlimage)
        MicroModal.close('modal__historico-atendimento_manager_new');
      }

    const handleSearchHistory = (textValue) => {
        setArrowTerm(0);
        setSearchText(textValue)
    }

    const handleScroll = e => {
        let element = e.target;
        let elmnt = document.getElementsByClassName("time");
      }

    const handleKeyUp = (inf) => {
        var elems = document.getElementsByTagName('mark');
        var tam	= elems.length;
    
        if(tam >= arrowterm+1){
          elems[arrowterm].scrollIntoView(false);
          if(inf == "less"){
            if(arrowterm != 0){
              setArrowTerm(arrowterm -1);
            }
          }else{
            setArrowTerm(arrowterm + 1);
          }
        }else{
          if(elems[arrowterm]){
            arrowterm = 0;
            elems[arrowterm].scrollIntoView(false);
          }
        }     
      }

    const searchWords = searchText.split(/\s/).filter(word => word);

    descHistory = HistoryData;

    return (
        <div
            className="modal micromodal-slide"
            id="modal__historico-atendimento_manager_new"
            aria-hidden="true"
            role="dialog"
        >
            <div className="modal__overlay" tabIndex="-1">
                    <div
                        className="modal__container"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="modal__historico-atendimento__title"
                    >
                    <header className="modal__header">
                        <h2
                            className="modal__title"
                            id="modal__historico-atendimento__title"
                        >
                        Interações
                        </h2>
                        <button
                            className="modal__close"
                            aria-label="Close modal"
                            data-micromodal-close
                        ></button>
                    </header>
                    <main
                        className="modal__content"
                        id="modal__historico-atendimento__content"
                    >
                        <div className="hist-atd__info">
                            <div className="hist-atd__info-items">
                                <p className="hist-atd__name  is-poppins">{nameClient}</p>
                                <i className="material-icons hist-atd__icon">question_answer</i> 
                                <span className="hist-atd__info-text">Total de&nbsp;
                                    <span className="hist-atd__counter">{descHistory.length}</span> 
                                    &nbsp;interações&#x28;s&#x29;
                                </span>
                            </div>
                        </div>
                        <div className="hist-atd__ctrls">
                            <p className="hist-atd__text">Período</p>
                            <span className="hist-atd__span">De:</span>
                            <input
                                type="datetime-local"
                                defaultValue={timedefaultinitmanager}
                                // ref={input => (this.datahistoryinitmanager = input)}
                                className="hist-atd__end"
                                id="hist_start_queue"
                                onChange={event => setHistStart(event.target.value)}
                            />
                            <span className="hist-atd__span">Até:</span>
                            <input
                                type="datetime-local"
                                defaultValue={timedefaultfimmanager}
                                // ref={input => (this.datahistoryfimmanager = input)}
                                className="hist-atd__end"
                                id="hist_end_queue"
                                onChange={event => setHistEnd(event.target.value)}
                            />
                            <button
                                className="hist-atd__search-btn"
                                onClick={() => SearchHistoryQueue('this','this.state.cdrid','this.state.cliente')}
                            >
                                Filtrar
                            </button>
                        </div>
                        <div className="hist-atd__content">
                            <div className={showHistory ? "hist-atd__search active": "hist-atd__search"}>
                                <span
                                    onClick={() => handleKeyUp("less")}
                                    className="material-icons hist-atd__search-icon"
                                >
                                expand_less
                                </span>
                                <span
                                    onClick={() => handleKeyUp("more")}
                                    className="material-icons hist-atd__search-icon"
                                >
                                expand_more
                                </span>
                                <input
                                    onChange={event => handleSearchHistory(event.target.value, 0)}
                                    type="text"
                                    className="hist-atd__search-input"
                                    placeholder="Pesquisar..."
                                />
                                <button
                                    onClick={() => setShowHistory(!showHistory)}
                                    className="hist-atd__search-btn hist-atd__search-btn--two"
                                >
                                Concluir
                                </button>
                            </div>
                        <div className="hist-atd__channel-info">
                            <img
                                className="hist-atd__channel-info-icon"
                                style={{ display: "none" }}
                                src={WHATSAPP}
                                alt=""
                                width="20"
                                height="20"
                            />
                            <div className="hist-atd__channel-info-time">
                                Interações
                            </div>
                        </div>
                        <div
                            className="hist-atd__wrapper"
                            onScroll={event => handleScroll(event)}
                        >
                            <div className="hist-atd__channel">
                                <div className="hist-atd__channel-chat active">
                                    {descHistory.map(history => (
                                    <div
                                        key={history.id}
                                        className={
                                        history.agente === true
                                            ? "message right"
                                            : "message left"
                                        }
                                    >
                                        {(() => {
                                        dia = history.diaenvio;
                                        mes = history.mesenvio;
                                        ano = history.anoenvio;
                                        mes = meses.indexOf(mes);
                                        dia = dia + " de " + meses[mes - 1];
                                        if (
                                            ano < history.anoenvio ||
                                            ano > history.anoenvio
                                        )
                                            dia = dia + " de " + history.anoenvio;
                                        if (dia != auxdia) {
                                            dia = dia;
                                            auxdia = dia;
                                        } else {
                                            auxdia = dia;
                                            dia = "";
                                        }
                                        })()}
                                        <div id={history.id} className="time">
                                        {dia}
                                        </div>
                                        <div className="bubble" id={'manager_'+history.id}>
                                        { 
                                            (() => {
                                                
                                            if(history.replyid > 0){
                                                var text = '';
                                                var array = []
                                                var posit = '';
                                                checkreply = true;

                                                    array = HistoryData.filter(msg => parseInt(msg.id) === parseInt(history.replyid))
                                                    if(array.length !== 0 && array){
                                                        posit = array[0].author
                                                        if(array[0].mimetypeid !== 1){
                                                        
                                                        var url	= array[0].messagem
                                                        url = url.substring(url.lastIndexOf('.') + 1);
                                                        switch (url.toLowerCase()) {
                                                            case "jpeg":
                                                            case "png":
                                                            case "jpg": {
                                                                return (
                                                                <a href={'#manager_'+history.replyid}>
                                                                <div className="reply-message active">
                                                                    <div className="reply-message__name">{posit === 'Me' ? 'Você':nameClient}</div>
                                                                        <div className="reply-message__text">
                                                                        <img src={FOTO} alt="" width="15" />   Imagem
                                                                        </div>
                                                                </div>
                                                                </a>
                                                                );
                                                            }
                                                            case "pdf":
                                                            return (
                                                                <a href={'#manager_'+history.replyid}>
                                                                <div className="reply-message active">
                                                                    <div className="reply-message__name">{posit === 'Me' ? 'Você':nameClient}</div>
                                                                        <div className="reply-message__text">
                                                                        <img src={DOC} alt="" width="15" />   PDF
                                                                        </div>
                                                                </div>
                                                                </a>
                                                            );
                                                            case "xls":
                                                            case "xlsx":
                                                            case "xlsm":
                                                            case "doc":
                                                            case "docx":
                                                            case "ppt":
                                                            case "pptx": {
                                                                return (
                                                                        <a href={'#manager_'+history.replyid}>
                                                                        <div className="reply-message active">
                                                                            <div className="reply-message__name">{posit === 'Me' ? 'Você':nameClient}</div>
                                                                                <div className="reply-message__text">
                                                                                <img src={DOC} alt="" width="15" />   DOC
                                                                                </div>
                                                                        </div>
                                                                        </a>
                                                                        );
                                                            }
                                                            case "wav":
                                                            case "mp3":
                                                            case "ogg":
                                                            case "mpeg": {
                                                            return (
                                                                    <a href={'#manager_'+history.replyid}>
                                                                        <div className="reply-message active">
                                                                            <div className="reply-message__name">{posit === 'Me' ? 'Você':nameClient}</div>
                                                                            <div className="reply-message__text">
                                                                                <img src={AUDIO} alt="" width="12" />   Áudio
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                            );
                                                            }
                                                            case "mp4": {
                                                            return (
                                                                <a href={'#manager_'+history.replyid}>
                                                                    <div className="reply-message active">
                                                                        <div className="reply-message__name">{posit === 'Me' ? 'Você':nameClient}</div>
                                                                        <div className="reply-message__text">
                                                                            <img src={VIDEO} alt="" width="15" />   Vídeo
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            );
                                                            }
                                                        }
                                                    }else{
                                                        text = array[0].messagem
                                                        if(text.length > 200)
                                                            text = text.substr(0,200)+'...';
                                                            text = text.replace(/¿/gi, "\n");
                                                            text = text.replace(/§/gi, "\r\n");
                                                            return (
                                                                    <a href={'#manager_'+history.replyid}>
                                                                    <div className="reply-message active">
                                                                        <div className="reply-message__name">{posit === 'Me' ? 'Você':nameClient}</div>
                                                                        <div className="reply-message__text">{text}</div>
                                                                    </div>
                                                                    </a>
                                                            );
                                                        }
                                                    }
                                                }
                                            //}
                                            })()
                                        }
                                        <div className="bubble-user-name">
                                            {checkreply === false ? history.agente === false ? nameClient : history.username : null}
                                        </div>
                                        <div className="text">
                                            {(() => {
                                            let caption = history.caption;
                                            if (caption == "null" || caption == null) {
                                                caption = "";
                                            } else {
                                                caption = caption.replace(/\\n/g, "\r\n");
                                            }
                                            var positmessage1 = "";
                                            var positmessage2 = "";
                                            if (history.is_from_agent === true) {
                                                positmessage1 = " right";
                                            }
                                            checkreply = false;
                                            if (history.mimetypeid == "1") {
                                                var mensagem_tratada = history.messagem;
                                                mensagem_tratada = history.messagem.replace(/\\n/gi, '\r\n');
                                                mensagem_tratada = history.messagem.replace(/¿/gi, "\n");
                                                mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
                                                let valor = 1
                                                try{
                                                mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
                                                var obj = JSON.parse(mensagem_tratada);
                                                mensagem_tratada = obj[1][0].mensagem_tratada
                                                } catch(e){
                                                mensagem_tratada = history.messagem;
                                                mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
                                                mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
                                                mensagem_tratada = mensagem_tratada.replace(/[^A-ZÀ-Ú a-zà-ú 0-9 , . ? ! *  # ; : '-' _ + § ¿ { } ' " ª \\ \ ]/g, '')
                                                mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
                                                var obj = JSON.parse(mensagem_tratada);
                                                mensagem_tratada = obj[1][0].mensagem_tratada
                                                mensagem_tratada = mensagem_tratada.replace(/ªª/gi, "\r\n");
                                                }
                                                return (
                                                <div>
                                                    <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={mensagem_tratada}
                                                    sanitize={latinize}
                                                    />
                                                    <span className="text__end-spacing"></span>
                                                </div>
                                                );
                                            } else {
                                                if (history.mimetypeid == "2") {
                                                if (testJson(history.messagem) === true) {
                                                    let json = JSON.parse(history.messagem);
                                                    let options = json.options;
                                                    let i = 1;
                                                    var opcoes = [];
                                                    for (i in options) {
                                                    opcoes.push(
                                                        i + " - " + options[i][1]
                                                    );
                                                    }
                                                    return (
                                                    <div>
                                                        <Highlighter
                                                        highlightClassName="YourHighlightClass"
                                                        searchWords={searchWords}
                                                        autoEscape={true}
                                                        textToHighlight={
                                                            json.msg + " \r\n "
                                                        }
                                                        sanitize={latinize}
                                                        />
                                                        <Highlighter
                                                        highlightClassName="YourHighlightClass"
                                                        searchWords={searchWords}
                                                        autoEscape={true}
                                                        textToHighlight={opcoes.join(
                                                            "  \r\n  "
                                                        )}
                                                        sanitize={latinize}
                                                        />
                                                        <span className="text__end-spacing"></span>
                                                    </div>
                                                    );
                                                } else {
                                                    return (
                                                    <div>
                                                        <Highlighter
                                                        highlightClassName="YourHighlightClass"
                                                        searchWords={searchWords}
                                                        autoEscape={true}
                                                        textToHighlight={history.messagem}
                                                        />
                                                        <span className="text__end-spacing"></span>
                                                    </div>
                                                    );
                                                }
                                                
                                            }else if(history.mimetypeid == "30"){
                                                if (testJson(history.messagem) === true){
                                                let json = JSON.parse(history.messagem);
                                                let options = json.options;
                                                let i = 1;
                                                var opcoes = [];
                                                for (i in options) {
                                                    opcoes.push(i+" - "+options[i][1]);
                                                }
                                                if(json.MSG){
                                                    return (
                                                        <div>
                                                            <Highlighter
                                                                highlightClassName="YourHighlightClass"
                                                                searchWords={searchWords}
                                                                autoEscape={true}
                                                                textToHighlight={json.MSG+" \r\n "}
                                                                sanitize={latinize}
                                                            />   
                                                            <Highlighter
                                                                highlightClassName="YourHighlightClass"
                                                                searchWords={searchWords}
                                                                autoEscape={true}
                                                                textToHighlight={opcoes.join( "  \r\n  " )}
                                                                sanitize={latinize}
                                                            />
                                                            <span className="text__end-spacing"></span> 
                                                        </div>                                                                   
                                                    );
                                                }else if(json.URL){
                                                    return (
                                                        <div>
                                                            <Highlighter
                                                                highlightClassName="YourHighlightClass"
                                                                searchWords={searchWords}
                                                                autoEscape={true}
                                                                textToHighlight={json.URL+" \r\n "}
                                                                sanitize={latinize}
                                                            />   
                                                            <Highlighter
                                                                highlightClassName="YourHighlightClass"
                                                                searchWords={searchWords}
                                                                autoEscape={true}
                                                                textToHighlight={opcoes.join( "  \r\n  " )}
                                                                sanitize={latinize}
                                                            />
                                                            <span className="text__end-spacing"></span> 
                                                        </div>                                                                   
                                                    );
                                                }
                                                }
                                            } else if (
                                                history.mimetypeid == "3" ||
                                                history.mimetypeid == "4" ||
                                                history.mimetypeid == "5" ||
                                                history.mimetypeid >= "6"
                                                ) {
                                                let separador = history.messagem.split(
                                                    "."
                                                );
                                                switch (separador[1]) {
                                                    case "jpeg":
                                                    case "png":
                                                    case "PNG":
                                                    case "jpg":
                                                    return (
                                                        <div className="bubble-media">
                                                        <div
                                                            className="bubble-media__image"
                                                            onClick={e =>
                                                            VerifierImage(
                                                                e,
                                                                connection_platform.type_connect+'://' +
                                                                ipcurrent+
                                                                history.messagem,
                                                                "history"
                                                            )
                                                            }
                                                        >
                                                            {isOpen && (
                                                            <Lightbox
                                                                mainSrc={
                                                                urlimage
                                                                }
                                                                onCloseRequest={e =>
                                                                CloseImage(
                                                                    e,
                                                                    "history"
                                                                )
                                                                }
                                                            />
                                                            )}
                                                            <img
                                                            src={
                                                                connection_platform.type_connect+'://' +
                                                                ipcurrent+
                                                                history.messagem
                                                            }
                                                            alt=""
                                                            />
                                                        </div>
                                                        <div className="bubble-media__mediaInfo">
                                                            <span className="bubble-media__fileType">
                                                            <img
                                                                className="bubble-media__fileIcon"
                                                                src={JPG}
                                                                alt=""
                                                            />
                                                            </span>
                                                            <span className="bubble-media__fileName">
                                                            <p className="bubble-media__text">
                                                                Nome do Arquivo
                                                            </p>
                                                            <br />
                                                            <div className="fileinfo__bar">
                                                                <span className="fileinfo__size">
                                                                {dbfileSize(
                                                                    history.filesize
                                                                )}
                                                                </span>{" "}
                                                                •{" "}
                                                                <span className="fileinfo__type">
                                                                {""}
                                                                </span>
                                                            </div>
                                                            </span>
                                                            { 
                                                                    (() => { 
                                                                        if(InfoUsers.permdownload === true){
                                                                        return(
                                                                        <div className="bubble-media__download">
                                                                        <a
                                                                            href={
                                                                            connection_platform.type_connect+'://' +
                                                                            ipcurrent+
                                                                            history.messagem
                                                                            }
                                                                            target="_blank"
                                                                            download
                                                                            className="bubble-media__btnDownload"
                                                                        >
                                                                            <i className="material-icons">
                                                                            get_app
                                                                            </i>
                                                                        </a>
                                                                        </div>
                                                                                                )
                                                                        }
                                                                    })()    
                                                            }
                                                            
                                                        </div>
                                                        </div>
                                                    );
                                                    break;
                                                    case "pdf":
                                                    return (
                                                        <div className="bubble-media">
                                                        <div className="bubble-media__mediaInfo">
                                                            <span className="bubble-media__fileType">
                                                            <img
                                                                className="bubble-media__fileIcon"
                                                                src={PDF}
                                                                alt=""
                                                            />
                                                            </span>
                                                            <span className="bubble-media__fileName">
                                                            <p className="bubble-media__text">
                                                                Nome do Arquivo
                                                            </p>
                                                            <br />
                                                            <div className="fileinfo__bar">
                                                                <span className="fileinfo__size">
                                                                {dbfileSize(
                                                                    history.filesize
                                                                )}
                                                                </span>{" "}
                                                                •{" "}
                                                                <span className="fileinfo__type">
                                                                {""}
                                                                </span>
                                                            </div>
                                                            </span>
                                                            { 
                                                                    (() => { 
                                                                        if(InfoUsers.permdownload === true){
                                                                        return(
                                                                        <div className="bubble-media__download">
                                                                        <a
                                                                            href={
                                                                            connection_platform.type_connect+'://' +
                                                                            ipcurrent+
                                                                            history.messagem
                                                                            }
                                                                            target="_blank"
                                                                            download
                                                                            className="bubble-media__btnDownload"
                                                                        >
                                                                            <i className="material-icons">
                                                                            get_app
                                                                            </i>
                                                                        </a>
                                                                        </div>
                                                                                                )
                                                                        }
                                                                    })()    
                                                            }
                                                            
                                                        
                                                        </div>
                                                        </div>
                                                    );
                                                    break;
                                                    case "xls":
                                                    case "xlsx":
                                                    case "xlsm":
                                                    case "doc":
                                                    case "docx":
                                                    case "ppt":
                                                    case "pptx":
                                                    return (
                                                        <div className="bubble-media">
                                                        <div className="bubble-media__mediaInfo">
                                                            <span className="bubble-media__fileType">
                                                            <img
                                                                className="bubble-media__fileIcon"
                                                                src={XLS}
                                                                alt=""
                                                            />
                                                            </span>
                                                            <span className="bubble-media__fileName">
                                                            <p className="bubble-media__text">
                                                                Nome do Arquivo
                                                            </p>
                                                            <br />
                                                            <div className="fileinfo__bar">
                                                                <span className="fileinfo__size">
                                                                {dbfileSize(
                                                                    history.filesize
                                                                )}
                                                                </span>{" "}
                                                                •{" "}
                                                                <span className="fileinfo__type">
                                                                {""}
                                                                </span>
                                                            </div>
                                                            </span>
                                                            { 
                                                                    (() => { 
                                                                        if(InfoUsers.permdownload === true){
                                                                        return(
                                                                        <div className="bubble-media__download">
                                                                        <a
                                                                            href={
                                                                            connection_platform.type_connect+'://'+
                                                                            ipcurrent+
                                                                            history.messagem
                                                                            }
                                                                            target="_blank"
                                                                            download
                                                                            className="bubble-media__btnDownload"
                                                                        >
                                                                            <i className="material-icons">
                                                                            get_app
                                                                            </i>
                                                                        </a>
                                                                        </div>
                                                                            )
                                                                        }
                                                                    })()    
                                                            }
                                                            
                                                        </div>
                                                        </div>
                                                    );
                                                    break;
                                                    case "wav":
                                                    case "mp3":
                                                    case "ogg":
                                                    case "mpeg":
                                                    return (
                                                        <div className="bubble-media">
                                                        <div className="bubble-media__playerBar">
                                                            <audio controls>
                                                            <source
                                                                src={
                                                                connection_platform.type_connect+'://'+
                                                                ipcurrent+
                                                                history.messagem
                                                                }
                                                                type="audio/ogg"
                                                            />
                                                            <source
                                                                src={
                                                                connection_platform.type_connect+'://'+
                                                                ipcurrent+
                                                                history.messagem
                                                                }
                                                                type="audio/mpeg"
                                                            />
                                                            Your browser.
                                                            </audio>
                                                        </div>
                                                        <div className="bubble-media__mediaInfo">
                                                            <span className="bubble-media__fileType">
                                                            <img
                                                                className="bubble-media__fileIcon"
                                                                src={MP3}
                                                                alt=""
                                                            />
                                                            </span>
                                                            <span className="bubble-media__fileName">
                                                            <p className="bubble-media__text">
                                                                Nome do Arquivo
                                                            </p>
                                                            <br />
                                                            <div className="fileinfo__bar">
                                                                <span className="fileinfo__size">
                                                                {dbfileSize(
                                                                    history.filesize
                                                                )}
                                                                </span>{" "}
                                                                •{" "}
                                                                <span className="fileinfo__type">
                                                                {""}
                                                                </span>
                                                            </div>
                                                            </span>
                                                            { 
                                                                    (() => { 
                                                                        if(InfoUsers.permdownload === true){
                                                                        return(
                                                                        <div className="bubble-media__download">
                                                                        <a
                                                                            href={
                                                                            connection_platform.type_connect+'://' +
                                                                            ipcurrent+
                                                                            history.messagem
                                                                            }
                                                                            target="_blank"
                                                                            download
                                                                            className="bubble-media__btnDownload"
                                                                        >
                                                                            <i className="material-icons">
                                                                            get_app
                                                                            </i>
                                                                        </a>
                                                                        </div>
                                                                            )
                                                                        }
                                                                    })()    
                                                            }
                                                        
                                                        </div>
                                                        </div>
                                                    );
                                                    break;
                                                    case "mp4":
                                                    return (
                                                        <div className="bubble-media">
                                                        <div className="bubble-media__video">
                                                            <video
                                                            className="bubble-media__video-frame"
                                                            controls
                                                            >
                                                            <source
                                                                className="bubble-media__video-file"
                                                                src={
                                                                connection_platform.type_connect+'://' +
                                                                ipcurrent+
                                                                history.messagem
                                                                }
                                                                type="video/mp4"
                                                            />
                                                            Seu navegador nao suporta esse
                                                            tipo de arquivo.
                                                            </video>
                                                        </div>
                                                        <div className="bubble-media__mediaInfo">
                                                            <span className="bubble-media__fileType">
                                                            <img
                                                                className="bubble-media__fileIcon"
                                                                src={AVI}
                                                                alt=""
                                                            />
                                                            </span>
                                                            <span className="bubble-media__fileName">
                                                            <p className="bubble-media__text">
                                                                Nome do Arquivo
                                                            </p>
                                                            <br />
                                                            <div className="fileinfo__bar">
                                                                <span className="fileinfo__size">
                                                                {dbfileSize(
                                                                    history.filesize
                                                                )}
                                                                </span>{" "}
                                                                •{" "}
                                                                <span className="fileinfo__type">
                                                                {""}
                                                                </span>
                                                            </div>
                                                            </span>
                                                            { 
                                                                    (() => { 
                                                                        if(InfoUsers.permdownload === true){
                                                                        return(
                                                                        <div className="bubble-media__download">
                                                                            <a
                                                                            href={
                                                                                connection_platform.type_connect+'://'+
                                                                                ipcurrent+
                                                                                history.messagem
                                                                            }
                                                                            target="_blank"
                                                                            download
                                                                            className="bubble-media__btnDownload"
                                                                            >
                                                                            <i className="material-icons">
                                                                                get_app
                                                                            </i>
                                                                            </a>
                                                                        </div>
                                                                            )
                                                                        }
                                                                    })()    
                                                            }
                                                        
                                                        
                                                        </div>
                                                                            </div>
                                                                        );
                                                                        break;
                                                                        default:
                                                                    }
                                                                    }
                                                                }
                                            })()}
                                        </div>
                                        <div className="text">
                                            {(() => {
                                            let caption = history.caption;
                                            if (caption == "null" || caption == null) {
                                                caption = "";
                                            } else {
                                                caption = caption.replace(/\\n/g, "\r\n");
                                            }
                                            return caption;
                                            })()}
                                        </div>
                                        <div className="bubble__info-content">
                                            <div className="fav fav--inside fav--right">
                                            {/* <i className="material-icons fav-icon">star_border</i> */}
                                            </div>
                                            <div className="bubble__info-content__time">
                                            {history.horaenvio}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    </main>

                    <button
                        className="hist-atd__fab"
                        onClick={() => setShowHistory(!showHistory)}
                    >
                        <i className="material-icons">search</i>
                    </button>

                    <div className="modal__content__form__group modal__content__form__group--col-1">
                        <a
                        className="modal__content__form__group__button modal__content__form__group__button--text"
                        data-micromodal-close
                        >
                        <i className="material-icons" data-micromodal-close>
                            arrow_back
                        </i>
                        Voltar
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );

}